module.exports = __webpack_public_path__ + "static/media/collins.e5d4a2f1.jfif";